module.exports = __webpack_public_path__ + "media/styles/images/svg/baruch-logo_horizontal-teal-f96d60fd0729f1afed699b097275eb9d.svg";